/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.bell\":\"Soittokello\"}");